export default __webpack_public_path__ + "static/Pear@2x-d8b57a58d277d5c16f5e14cd21f47dd9.png";